// extracted by mini-css-extract-plugin
module.exports = {"innerMargin":"OwnerLinkAccount_innerMargin__1QXIe","innerMarginWithBorder":"OwnerLinkAccount_innerMarginWithBorder__2sbY7","buttonMargin":"OwnerLinkAccount_buttonMargin__2TVsW"};